<template>
  <SlideView
    validation-mode
    with-annotations
    with-annotation-details
    :float-mode="floatMode"
    @float-mode:changed="floatMode = $event"
  ></SlideView>
</template>

<script>
import SlideView from "@/components/slide/SlideView";

export default {
  components: { SlideView },
  data() {
    return {
      floatMode: true
    };
  }
};
</script>

<style scoped></style>
